import React, {useContext, useState} from 'react'
import {observer} from 'mobx-react-lite'
import {groupBy as rowGrouper} from 'lodash'
import DataGrid from 'react-data-grid'
import {Row, Col, Button} from 'react-bootstrap'

import StoryContext from '../store/context'
import {format_time, format_date} from '../utils/formatDate'
import {er, exportToXlsx} from '../utils/exportUtils'

const _max = (arr = [], groups = []) => {
  const arr_new = []
  for (const it of arr) {
    let t = false
    for (const it2 of arr_new) {
      let t1 = true
      for (const it3 of groups) {
        if (it[it3] !== it2[it3]) {
          t1 = false
        }
      }
      if (t1 === true) {
        t = true
        break
      }
    }
    if (t === false) {
      const o = {}
      for (const it4 of groups) {
        o[it4] = it[it4]
      }
      arr_new.push(o)
    }
  }
  return arr_new
}

const merchs = [
  {
    name: 'Команда',
    key: 'team',
  },
  {
    name: 'Робіник',
    key: 'merch',
  },
  {
    name: 'День',
    key: 'date',
  },
  {
    name: 'Точки',
    key: 'total_outlets',
    formatter: ({row, column}) => (
      <div
        style={{
          textAlign: 'center',
        }}></div>
    ),
    width: 5,
    groupFormatter({childRows}) {
      return (
        <div style={{textAlign: 'center'}}>
          {`${_max(childRows, ['merch', 'total_outlet']).reduce(
            (prev, {total_outlet}) => prev + total_outlet,
            0,
          )}/${_max(childRows, ['merch', 'total_outlet_all']).reduce(
            (prev, {total_outlet_all}) => prev + total_outlet_all,
            0,
          )}`}
        </div>
      )
    },
  },
  {
    name: 'Дні',
    key: 'total_days',
    formatter: ({row, column}) => (
      <div
        style={{
          textAlign: 'center',
        }}>{`${row.total_days}/${row.total_days_all}`}</div>
    ),
    width: 5,
    groupFormatter({childRows}) {
      return (
        <div style={{textAlign: 'center'}}>
          {`${childRows.reduce(
            (prev, {total_days}) => prev + total_days,
            0,
          )}/${childRows.reduce(
            (prev, {total_days_all}) => prev + total_days_all,
            0,
          )}`}
        </div>
      )
    },
  },
  {
    name: 'Часи',
    key: 'total_hours',
    formatter: ({row, column}) => (
      <div
        style={{
          textAlign: 'center',
        }}>
        {`${row.total_hours_work}/${row.total_hours}`}
      </div>
    ),
    width: 5,
  },
  {
    name: 'Візити',
    key: 'total_visits',
    formatter: ({row, column}) => (
      <div
        style={{
          textAlign: 'center',
        }}>{`${row.total_visits}/${row.total_visits_all} - ${row.total_visits_add} `}</div>
    ),
    width: 5,
    groupFormatter({childRows}) {
      return (
        <div style={{textAlign: 'center'}}>
          {`${childRows.reduce(
            (prev, {total_visits}) => prev + total_visits,
            0,
          )} / ${childRows.reduce(
            (prev, {total_visits_all}) => prev + total_visits_all,
            0,
          )} - ${childRows.reduce(
            (prev, {total_visits_add}) => prev + total_visits_add,
            0,
          )}`}
        </div>
      )
    },
  },
]

const Report = observer(() => {
  const store = useContext(StoryContext)
  const [date1, setDate1] = useState(format_date(Date.now()))
  const [date2, setDate2] = useState(format_date(Date.now()))
  const [expandedGroupIds, setExpandedGroupIds] = useState(new Set())

  const i = store.reportmerch.map(
    ({
      team,
      merch,
      category,
      date,
      total_hours,
      total_days,
      total_visits_add,
      total_visits,
      total_visits_all,
      total_days_all,
      total_outlet_all,
      total_hours_work,
      total_outlet,
    }) => ({
      team: team.name,
      merch: merch.name,
      category,
      date,
      total_hours,
      total_days,
      total_visits_add,
      total_visits,
      total_visits_all,
      total_days_all,
      total_hours_work,
      total_outlet_all,
      total_outlet,
    }),
  )

  const gridElement = (
    <DataGrid
      style={{height: 600, marginTop: 5}}
      columns={merchs}
      rows={i}
      groupBy={['team', 'merch']}
      rowGrouper={rowGrouper}
      expandedGroupIds={expandedGroupIds}
      onExpandedGroupIdsChange={setExpandedGroupIds}
      defaultColumnOptions={{
        sortable: true,
        resizable: true,
      }}
    />
  )

  return (
    <>
      <Row>
        <Col>
          <input
            name="requested_order_ship_date"
            value={date1}
            type="date"
            className="form-control"
            onChange={event => setDate1(event.target.value)}
          />
        </Col>
        <Col>
          <input
            name="requested_order_ship_date"
            value={date2}
            type="date"
            className="form-control"
            onChange={event => setDate2(event.target.value)}
          />
        </Col>
        <Col>
          <Button onClick={() => store.getPeriod(date1, date2)}>
            Сформувати
          </Button>{' '}
          <Button onClick={() => er(i)}>Экспорт</Button>
        </Col>
      </Row>
      {gridElement}
    </>
  )
})

export default Report
